export const vanity = process.env.REACT_APP_VANITY_TYPEFORM as string;
export const pro = process.env.REACT_APP_PROFILE_TYPEFORM as string;
export const survey = process.env.REACT_APP_PARTICIPATION_TYPEFORM as string;
export const event = process.env.REACT_APP_EVENT_TYPEFORM as string;
export const email = process.env.REACT_APP_SENDGRID_TYPEFORM as string;
export const form = process.env.REACT_APP_FORM_ADDER_TYPEFORM as string
export const unauthorized_form = process.env.REACT_APP_UNAUTHORIZED_TYPEFORM as string;
